<template>
    <div>
        <app-header></app-header>

        <div class='section'>
            <h1 id="scenes-title" class="title is-capitalized has-text-centered">Scenes</h1>
        </div>

        <scene-details></scene-details>
        
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        methods: {
        },
        mounted() {
        },
    }
</script>

<style scoped lang="scss">
    // this should inherit from App.vue but I dont know how
    $den_offwhite: #dddbd4;

    #scenes-title.title {
        color: $den_offwhite;
    }
</style>